<template>
  <div>
    <div class="table-cadu">
      <v-row align="center" no-gutters>
        <v-col cols="auto" v-if="rows.length > 0"> Exibir </v-col>

        <v-col cols="auto" v-if="rows.length > 0">
          <v-select
            class="relative primary1--text"
            full-width
            color="primary1"
            item-color="primary1"
            :append-icon="'$vuetify.icons.chevron-down'"
            :items="items"
            v-model="elementsPerPage"
            @input="changeElement"
          />
        </v-col>

        <v-col cols="auto" v-if="rows.length > 0"> resultados </v-col>

        <v-row :class="$vuetify.breakpoint.xs ? 'align-center justify-center' : 'align-end justify-end'">
          <v-col cols="auto">
            <button-cadu @click="$emit('click')">
              FILTRAR
            </button-cadu>
          </v-col>
        </v-row>
      </v-row>

      <div>
        <div
          class="table overflow"
          :style="$vuetify.breakpoint.xs ? { width: '229px;', height: '100%;', overflow: 'auto' } : {}"
        >
          <transition name="fade">
            <v-row v-if="showSelected" class="selected">
              <v-col cols="auto">
                <div class="primary1--text font-weight-bold title">{{ selectedSize }} Itens selecionados</div>
              </v-col>
              <v-row align="end" justify="end">
                <v-col cols="auto">
                  <button-rounded
                    class="mr-9"
                    @click="$emit('clickButton', { selected, type: 'delAll' })"
                    iconName="trash"
                    :iconSize="16"
                  />
                </v-col>
              </v-row>
            </v-row>
          </transition>

          <table
            v-if="!loading"
            rules="groups"
            :style="!$vuetify.breakpoint.xs ? { width: '229px;', height: '100%;', overflow: 'auto' } : {}"
          >
            <thead @mouseover="hoverRow(-1)" @mouseleave="downRow">
              <tr>
                <th v-if="showCheck">
                  <label class="form-checkbox">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @click="select"
                      :disabled="rows.length <= 0 || !opcaoEditar"
                    />
                    <icon class="form-icon white--text" style="border-color: #60656c;" name="check" :size="16" />
                  </label>
                </th>

                <th v-for="(col, index) in rowsHeader" :key="index">
                  <div v-if="col.icon" style="cursor: pointer; width: 64px;" @click="ordernaArea(index)">
                    {{ col.text }} <icon style="transform: rotate(90deg);" :name="col.icon" :size="20" />
                  </div>
                  <div v-else>
                    {{ col.text }}
                  </div>
                  <div v-if="col == sortColumn" class="font-weight-bold"></div>
                </th>
              </tr>
            </thead>

            <tbody v-if="rows.length > 0">
              <slot name="body">
                <tr v-for="(row, index) in rows" :key="index" @mouseover="hoverRow(index)" @mouseleave="downRow">
                  <td v-if="showCheck">
                    <label class="form-checkbox">
                      <input type="checkbox" :value="row.id" v-model="selected" :disabled="!opcaoEditar" />
                      <icon class="form-icon white--text" name="check" :size="16" />
                    </label>
                  </td>
                  <td>{{ row.tipoArea.nome }}</td>
                  <td>{{ row.emailArea.endereco }}</td>
                  <td>{{ row.nomeResponsavel }}</td>

                  <td class="pa-0 pl-2">
                    <!-- <icon
                      v-if="row.statusEmail === 2 && !showStatusEmail(hoverIndex, index)"
                      name="check"
                      :size="12"
                      class="primary1--text"
                    />

                    <span
                      v-else-if="row.statusEmail === 1 && !showStatusEmail(hoverIndex, index)"
                      class="warningUtil2--text"
                      style="font-size: 14px;"
                    >
                      !
                    </span>

                    <icon
                      v-else-if="row.statusEmail === 0 && !showStatusEmail(hoverIndex, index)"
                      name="x"
                      :size="12"
                      class="error--text"
                    /> -->

                    <div style="display: inline-flex;" v-if="showActionsLine(hoverIndex, index)">
                      <button-rounded
                        style="width: 26px;"
                        class="mr-1"
                        @click="$emit('clickButton', { index, selected, type: 'view' })"
                        iconName="eye"
                        :iconSize="16"
                      />

                      <button-rounded
                        style="width: 26px;"
                        class="mr-1"
                        @click="$emit('clickButton', { index, selected, type: 'edit' })"
                        iconName="edit"
                        :iconSize="16"
                        v-if="opcaoEditar"
                      />

                      <button-rounded
                        style="width: 26px;"
                        @click="$emit('clickButton', { index, selected, type: 'delete' })"
                        iconName="trash"
                        :iconSize="16"
                        v-if="opcaoEditar"
                      />
                    </div>
                  </td>
                </tr>
              </slot>
            </tbody>
          </table>

          <div style="text-align: center;" v-if="rows.length == 0">Nenhum registro encontrado</div>

          <component-loading style="height: 256px;" v-else :value="loading" />
        </div>
      </div>

      <v-row align="start" justify="start" v-if="rows.length > 0">
        <v-col cols="auto">
          <div>Exibindo página {{ currentPage }} de {{ rowsLength }} {{ rowsLength > 1 ? 'páginas' : 'página' }}.</div>
        </v-col>

        <v-row align="end" justify="end">
          <v-col cols="auto">
            <button class="set" :disabled="currentPage === 1" @click="change_page(1)">
              <icon name="chevrons-left" :size="12" />
            </button>
            <button class="set" :disabled="currentPage === 1" @click="change_page(currentPage - 1)">
              <icon name="chevron-left" :size="12" />
            </button>
            <div
              class="number"
              v-for="(i, index) in num_pages()"
              :key="index"
              :class="[i === currentPage ? 'active' : '']"
              @click="change_page(i)"
            >
              {{ i }}
            </div>
            <button
              class="set"
              :disabled="currentPage === qtPaginas || qtPaginas === 0"
              @click="change_page(currentPage + 1)"
            >
              <icon name="chevron-right" :size="12" />
            </button>
            <button
              class="set"
              :disabled="currentPage === qtPaginas || qtPaginas === 0"
              @click="change_page(qtPaginas)"
            >
              <icon name="chevrons-right" :size="12" />
            </button>
          </v-col>
        </v-row>
      </v-row>

      <v-row v-if="texto && opcaoEditar">
        <v-col>
          <a @click="$emit('clickButton', { type: 'add' })" style="color: #1492e6;"> {{ texto }} </a>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagina: {
      type: Number,
      required: false,
      default: 1
    },
    qtPaginas: {
      type: Number,
      required: false,
      default: 1
    },
    qtResultados: {
      type: Number,
      required: false,
      default: 1
    },
    items: {
      type: Array,
      required: false
    },
    tableRows: {
      type: Array,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    },
    showCheck: {
      type: Boolean,
      note: 'Mostrar os checks na tabela'
    },
    elementsPerPageProp: {
      type: String
    },
    ordemProp: {
      type: String,
      default: 'asc'
    }
  },
  data() {
    return {
      drawer: false,
      rows: this.tableRows,
      rowsHeader: [
        { text: 'Área', icon: 'repeat' },
        { text: 'E-mail da Área', icon: 'repeat' },
        { text: 'Nome do Responsável', icon: 'repeat' },
        //{ text: 'Status E-mails' }
      ],
      texto: '+ adicionar área',
      selected: [],
      selectAll: false,
      currentPage: 1,
      ascending: false,
      sortColumn: '',
      hoverIndex: -1,
      button: [],
      showButton: false,
      showSelected: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      ordem: 'asc',
      elementsPerPage: this.elementsPerPageProp
    }
  },
  beforeMount() {
    this.currentPage = this.pagina
    let s = String(this.elementsPerPageProp)
    this.elementsPerPage = s.length < 2 ? `0${s}` : s
  },
  methods: {
    changeElement(value) {
      this.elementsPerPage = value
      this.selectAll = false
      this.selected = []
      this.currentPage = 1
      this.$emit('elements-per-page-change', this.elementsPerPage)
    },
    showStatusEmail(hoverIndex, index) {
      return hoverIndex === index ? true : false
    },
    showActionsLine(hoverIndex, index) {
      if (this.showSelected) {
        return false
      } else if (this.selected.length === 1) {
        if (hoverIndex >= 0) {
          if (this.rows[index].id === this.selected[0]) {
            return true
          } else {
            return false
          }
        }
      } else if (hoverIndex === index) {
        return true
      } else {
        return false
      }
    },
    ordernaArea(index) {
      let ordem = this.ordemProp === 'asc' ? 'desc' : 'asc'
      this.$emit('ordem', { index: index, ordem: ordem })
    },
    sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }

      var ascending = this.ascending

      this.rows.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    num_pages() {
      let pages = []
      let index = this.currentPage

      if (this.qtPaginas === 1) {
        pages = [index]
      } else if (index === 1 && this.qtPaginas === 2) {
        pages = [index, index + 1]
      } else if (index > 1 && this.qtPaginas === 2) {
        pages = [index - 1, index]
      } else if (index > 1 && index + 1 < this.qtPaginas) {
        pages = [index - 1, index, index + 1]
      } else if (index > 0 && index + 1 < this.qtPaginas) {
        pages = [index, index + 1, index + 2]
      } else if (!(index === this.qtPaginas) && this.qtPaginas - index < 2) {
        pages = [index - 1, index, index + 1]
      } else {
        pages = [index - 2, index - 1, index]
      }

      return pages
    },
    change_page(page) {
      if (page !== this.currentPage) {
        this.currentPage = page
        this.$emit('change-page', { currentPage: Number(this.currentPage) })
      }
    },
    select() {
      this.selected = []
      if (!this.selectAll) {
        for (let i in this.rows) {
          this.selected.push(this.rows[i].id)
          // let row = this.rows[this.currentPage][i]
          // this.selected.push(row.id)
        }
      }
    },
    hoverRow(index) {
      this.showButton = true
      this.hoverIndex = index
    },
    downRow() {
      this.hoverIndex = -100
      this.showButton = false
    },
    cleanSelected() {
      this.selected = []
    }
  },
  computed: {
    columns() {
      if (this.rows.length === 0) {
        return []
      }
      return Object.keys(this.rows[0])
    },
    mostrandoLength() {
      return this.rows.length < 10 ? `0${this.rows.length}` : this.rows.length
    },
    rowsLength() {
      return Math.ceil(this.qtResultados / this.elementsPerPage)
    },
    selectedSize() {
      return this.selected.length < 10 ? `0${this.selected.length}` : this.selected.length
    }
  },
  watch: {
    selected() {
      if (this.selected.length >= 2) {
        this.showSelected = true
      } else {
        this.selectAll = false
        this.showSelected = false
      }
      if (this.selected.length === this.rows.length) {
        this.selectAll = true
      }
    },
    tableRows() {
      this.rows = this.tableRows
    },
    pagina() {
      this.currentPage = this.pagina
    },
    elementsPerPageProp() {
      this.elementsPerPage = this.elementsPerPageProp
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/sass/table.sass'

.overflow
  display: block
  overflow-x: auto
  white-space: nowrap

.table-cadu
    border: none
    border-radius: 0px
    width: 100%

table
    width: 100%
</style>
